import { render, staticRenderFns } from "./StatsTab.vue?vue&type=template&id=5b8e4b28&scoped=true"
import script from "./StatsTab.vue?vue&type=script&lang=js"
export * from "./StatsTab.vue?vue&type=script&lang=js"
import style0 from "./StatsTab.vue?vue&type=style&index=0&id=5b8e4b28&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b8e4b28",
  null
  
)

export default component.exports